import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import sem_imagem from '../../assets/images/sem_imagem.png';
import img_pago from '../../assets/images/img_pago.jpg';
import img_parcial from '../../assets/images/img_parcial.jpg';
import img_fiado from '../../assets/images/img_fiado.jpg';
import { useProvider, Toast, isNative } from '../../context/MenuProvider';


const RenderizarFoto = ({ src, alt, className, width, height}) => {
  // Função para alterar a imagem em caso de erro
  const handleError = (e) => {
    e.target.src = sem_imagem;
  };
  const {
    site
  } = useProvider();
  
  const [finalSrc, setFinalSrc] = useState(src);
  
  // useEffect(() => {
  //   //if (!isNative) return;
  //   const domain = site?.domain || "";
  
  //   if (src && src.startsWith('/')) {
  //     setFinalSrc(`https://${domain}${src}`);
  //   }
    
  // }, [src, isNative, site?.domain]);


  return (
    <>
      <img
        width={width}
        height={height}
        src={finalSrc || sem_imagem}  // Fallback para sem_imagem
        alt={alt || ''}  // Nome do produto no alt
        className={className || "img-cortada-1"} 
        onError={handleError} // Função que define a imagem de fallback
        //crossorigin="anonymous"
      />
    </>
  );
}

export default RenderizarFoto;
